import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4.5-.5 3h-1l-.5-3h2Zm0 9-.5-3h-1l-.5 3h2Zm-2.5-4-3 .5v-2l3 .5v1Zm3 0 3 .5v-2l-3 .5v1Z" }));
export default createSvgIcon(iconPath, "Forgiveness");
//# sourceMappingURL=StatusForgivenessIcon.js.map